import { IconButton, Stack, Badge, Popover, Box, TextField, MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import api from "../services/api";


export default function InspectorFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [inspectores, setInspectores] = useState([]);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };


  useEffect(() => {
    api.get('/admins?funcao=Inspector&perPage=200')
      .then(response => {
        setInspectores(response.data.Admins)
      }).catch(err => '')
  }, [])

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.inspectorId}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>
          <TextField
            type="text"
            label="Filtro por Inspector"
            select
            style={{ width: 200 }}
            size="small"
            name="inspectorId"
            variant="outlined"
            onChange={(e) =>
              props.setInspectorId(e.target.value === "Geral" ? "" : e.target.value)
            }
            value={props.inspectorId}
          >
            <MenuItem value="Geral">Geral</MenuItem>
            {inspectores?.map((inspector) => (
              <MenuItem key={inspector._id} value={inspector?._id} >
                {inspector?.dadosPessoais?.nome}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Popover>
    </Stack>
  );
};


